import Vue from 'vue';
import ElementUI from 'element-ui';

console.log(ElementUI.Button.methods.handleClick);
ElementUI.Button.methods.handleClick = function (evt) {
  if (evt && evt.target && evt.target.blur) {
    evt.target.blur();
  }
  eval("this.$emit('click', evt)");
};

Vue.use(ElementUI);

if (window.registerComponent) {
  window.registerComponent(Vue);
}




// WEBPACK FOOTER //
// ./src/components/core/registerComponent.js